import React, { Component } from 'react';
import $j from 'jquery';
import PropTypes from 'prop-types';
import radium from 'radium';
import autobind from 'autobind-decorator';
import { Tooltip, SnackBarHelper, Icon as IconComponent } from '@lyearn-team/frontend-components';
import isURL from 'validator/lib/isURL';
import showVideoResponse from 'helper/uppy/videoUploader';

import { urlExists } from 'helper/urlExists';

import * as TinyPubSub from '../../../../helper/TinyPubSub';
import { interactionsBlocked } from '../../../../helper/blockUserInteractionHelper';
import VideoRecorder from '../../../helper/videoRecorder';
import Icon from '../../../../helper/Icon';
import { uploadToS3 } from '../../../helper/fileUpload';
import User from '../../../../helper/currentUser';

const videorecorder = new VideoRecorder();
const user = new User();

let styles = {};

class VideoResponse extends Component {
  static contextTypes = {
    showTroublePopup: PropTypes.func,
    checkForSubmit: PropTypes.func,
    getFeatureFlag: PropTypes.func,
    showLoading: PropTypes.func,
    hideLoading: PropTypes.func,
    type: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.uploadedFileObjectUrl = null;
    this.uploadedFile = null;
  }

  state = {
    // initialState: true, // Boolean if user opted to record video
    showingPreviewVideo: false, // Boolean if playing live preview video without recording
    uploadVideoPreview: false, // Boolean if uploaded a video file
    recordingVideo: false, // Boolean if a Video is being recorded
    recordedVideo: null, // Latest recorded video
    videoRecorded: false, // Boolean if a video is just recorded
    videoAvailable: (this.props.response && this.props.response.substr(0, 4) == 'http') || false, // Boolean if video is already avaliable/submitted from server
    unSupported: false, // Boolean if video recording is unsupported
    noVideo: true, // Boolean if video is available/submitted or not from server
    uploadingVideo: false, // Boolean if a video is being uploaded or not
    uploadSize: false, // Size of file being uploaded
    responseToBeSubmitted: null
  };

  UNSAFE_componentWillMount() {
    this.state.videoAvailable = this.props.response && this.props.response.substr(0, 4) === 'http';
  }

  componentDidMount() {
    this.checkForLocalVideo(`${this.props.questionId}_${this.props.cardId}`);

    if (
      window.location.protocol.indexOf('https') > -1 ||
      window.location.hostname.indexOf('localhost') > -1
    ) {
    } else {
      this.setState({
        unSupported: true
      });
    }

    this.videoPlayer = this.refs.videoPlayer;
    $j(this.videoPlayer).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', e => {
      const state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      const event = state ? 'FullscreenOn' : 'FullscreenOff';
      if (event === 'FullscreenOn') {
        $j('body').addClass('videoFullScreen');
      } else {
        $j('body').removeClass('videoFullScreen');
      }
    });
    this.progressBar = this.refs.progressBar;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      this.setState(
        {
          showingPreviewVideo: false,
          // initialState: !(nextProps.response.substr(0, 4) == 'http'),
          uploadVideoPreview: false,
          recordingVideo: false,
          recordedVideo: null,
          videoRecorded: false,
          videoAvailable: nextProps.response && nextProps.response.substr(0, 4) == 'http',
          unSupported: false,
          noVideo: true,
          uploadingVideo: false,
          uploadSize: false,
          responseToBeSubmitted: null
        },
        () => {
          this.checkForLocalVideo(`${nextProps.questionId}_${nextProps.cardId}`);
        }
      );
      this.uploadedFileObjectUrl = null;
      this.uploadedFile = null;
      videorecorder && videorecorder.clearStream && videorecorder.clearStream();
      this.videoPlayer && this.videoPlayer.setAttribute('controls', 'true');
      this.recordingTimerChange(false);
    }
    this.state.videoAvailable = nextProps.response && nextProps.response.substr(0, 4) === 'http';
  }

  componentDidUpdate() {
    this.videoPlayer = this.refs.videoPlayer;
    $j(this.videoPlayer).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', e => {
      const state = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
      const event = state ? 'FullscreenOn' : 'FullscreenOff';
      if (event === 'FullscreenOn') {
        $j('body').addClass('videoFullScreen');
      } else {
        $j('body').removeClass('videoFullScreen');
      }
    });
  }

  componentWillUnmount() {
    TinyPubSub.unsubscribe('UserInteractionBlockChange');
    // console.log(videorecorder);
    this.recordingTimerChange(false);
    videorecorder && videorecorder.clearStream && videorecorder.clearStream();
  }

  getUploadParameters = file => {
    const fileName =
      user.id() +
      '_' +
      this.props.cardId +
      '_q' +
      this.props.position +
      'v' +
      0 +
      '_' +
      new Date().getTime() +
      '.' +
      file.extension;
    const s3Url = global.constants.s3LyearnAssetsUrl + fileName;
    return Promise.resolve({
      method: 'PUT',
      url: s3Url,
      fields: {}
    });
  };

  onSelectMediaPressed = type => () => {
    window.fs_filepicker = window.filestack && window.filestack.init('AuG7ZQSxaSemtziJGYwbsz');
    this.context.showLoading();
    let fromSources = [];
    if (type === 'upload') {
      fromSources = ['local_file_system', 'googledrive', 'video'];
    } else if (type === 'record') {
      fromSources = ['video', 'googledrive', 'local_file_system'];
    }
    window.fs_filepicker
      .picker({
        fromSources,
        maxFiles: 1,
        minFiles: 1,
        accept: [
          'video/mp4',
          'video/x-m4v',
          'video/m4v',
          'video/quicktime',
          'video/mov',
          'video/x-msvideo',
          'video/avi'
        ],
        onOpen: () => {
          this.context.hideLoading();
        },
        onFileUploadFailed: (file, error) => {
          window.analytics.track('FILEPICKER_FILE_UPLOAD_FAILED', {
            cardId: this.props.cardId,
            recordOrUpload: type,
            error
          });
        },
        onFileUploadFinished: data => {
          try {
            window.analytics.track('FILEPICKER_FILE_UPLOAD_FINISHED', {
              cardId: this.props.cardId,
              fileUploadData: JSON.stringify(data),
              fileUrl: data.url,
              recordOrUpload: type
            });

            this.fileUploaded(data);
          } catch (e) {
            console.error(e);
          }
        }
      })
      .open();
  };

  responseDeleted = () => {
    this.setState({
      videoRecorded: false
    });
  };

  videoClicked = () => {
    const videoPlayer = this.refs.videoPlayer;
    if (videoPlayer.paused) {
      const p = videoPlayer.play();
      if (p && typeof Promise !== 'undefined' && p instanceof Promise) {
        p.catch(e => {
          console.log(`Caught pending play exception - continuing (${e})`);
        });
      }
    } else if (!this.state.recordingVideo) videoPlayer.pause();
  };

  renderPlayer = () => {
    const state = this.state;
    const { response, type } = this.props;

    if (
      response &&
      response.substr(0, 4) === 'http' &&
      !state.recordedVideo &&
      !state.uploadVideoPreview
    ) {
      let answerResponseExists = false;
      if (['FILE', 'IMAGE', 'VIDEO', 'AUDIO'].includes(type) && isURL(response)) {
        answerResponseExists = urlExists(response);
      } else {
        answerResponseExists = true;
      }
      return (
        <div style={styles.container}>
          {!answerResponseExists && (
            <div style={styles.apologyContainer}>
              <IconComponent style={styles.alertIcon} type="alert" />
              This submission has been lost due to a technical error on our part. Apologies for the
              inconvinience caused!
            </div>
          )}
          <video
            className="v1"
            ref="videoPlayer"
            style={styles.videoElement}
            onTouchTap={this.videoClicked.bind(this)}
            controls="controls"
            src={response}
          />
        </div>
      );
    }
    if (
      !state.videoAvailable &&
      !state.videoRecorded &&
      !state.recordingVideo &&
      !state.showingPreviewVideo &&
      !state.uploadVideoPreview &&
      (!state.responseToBeSubmitted || state.responseToBeSubmitted === '')
    ) {
      return (
        <video
          className="v2"
          ref="videoPlayer"
          style={styles.noVideo}
          onTouchTap={this.videoClicked.bind(this)}
          controls="controls"
          src={response}
        />
      );
    }
    if (state.uploadVideoPreview) {
      return (
        <video
          className="v3"
          ref="videoPlayer"
          style={styles.videoElement}
          onTouchTap={this.videoClicked.bind(this)}
          controls="controls"
          src={this.uploadedFileObjectUrl}
        />
      );
    }
    if (state.showingPreviewVideo || state.recordingVideo) {
      return <video className="v4" ref="videoPlayer" style={styles.videoElement} />;
    }
    if (state.videoRecorded && !!state.recordedVideo) {
      const videoUrl = state.recordedVideo;
      return (
        <div style={styles.container}>
          <div style={styles.previewLable}>Preview:</div>
          <video
            className="v5"
            ref="videoPlayer"
            style={styles.videoElement}
            controls={true}
            onTouchTap={this.videoClicked.bind(this)}
            src={videoUrl}
          />
        </div>
      );
    }
    if (state.responseToBeSubmitted && state.responseToBeSubmitted !== '') {
      const videoUrl = state.responseToBeSubmitted;
      return (
        <div style={styles.container}>
          <video
            className="v6"
            ref="videoPlayer"
            style={styles.videoElement}
            controls={true}
            onTouchTap={this.videoClicked.bind(this)}
            src={videoUrl}
          />
        </div>
      );
    }
    return null;
  };

  renderErrors = () => (
    <div>
      {this.state.uploadError &&
      !this.state.recordingVideo &&
      !this.state.videoRecorded &&
      !this.state.uploadingVideo ? (
        <p style={styles.uploadError}>
          Please upload only <span style={styles.strong}>MP4</span> or{' '}
          <span style={styles.strong}>WEBM</span> format
        </p>
      ) : null}
      {this.state.uploadFileSizeError &&
      !this.state.recordingVideo &&
      !this.state.videoRecorded &&
      !this.state.uploadingVideo ? (
        <p style={styles.uploadError}>{this.state.uploadFileSizeError.text}</p>
      ) : null}
    </div>
  );

  renderUploadingStatus = () => {
    let progressBarView = null;
    if (this.state.uploadingVideo) {
      progressBarView = (
        <div>
          <progress ref="progressBar" value="0" style={styles.progressBar} />
          <p style={styles.fileSize}>
            File size: {window.constants.humanFileSize(this.state.uploadSize, true)}
          </p>
        </div>
      );
    }
    return progressBarView;
  };

  renderVideoControls = () => {
    if (!this.show_VideoControls) return null;
    return (
      <div style={[styles.buttonsContainer, styles.videoControlsButtonContainer]}>
        <div
          style={[
            styles.retakeBtnIcon,
            styles.vc_Record,
            this.show_vc_RetakeButton ? null : styles.hideButton
          ]}
          key="retake"
          onClick={this.showPreviewClicked}
        >
          <Icon
            icon="retake-arrow"
            viewBox="0 0 28 33"
            svgTagAttributes={{ stroke: '#fff', strokeWidth: '1px' }}
            fill="#fff"
            size="22px"
          />
        </div>

        <div
          style={[
            styles.recordButton,
            styles.vc_Record,
            this.show_RecordButton ? null : styles.hideButton
          ]}
          key="record"
          onClick={this.recordVideo}
        >
          <span style={styles.recordBtnInnerCircle} />
        </div>

        <div
          style={[
            styles.recordButton,
            styles.vc_Record,
            this.show_StopButton ? null : styles.hideButton
          ]}
          key="stop"
          onClick={this.stopVideo}
        >
          <span style={styles.stopBtnInnerCircle} />
        </div>
      </div>
    );
  };

  renderButtons = () => (
    <div>
      <div style={styles.buttonsContainer}>
        <div
          style={[styles.deleteButton, this.show_CancelButton ? null : styles.hideButton]}
          key="cancel"
          onClick={this.cancelRecorded}
        >
          CANCEL
        </div>
        {!this.show_ModeSelector &&
        !this.toBeSubmittedAvailable &&
        !this.state.uploadVideoPreview &&
        !this.uploadedFile &&
        !this.state.uploadingVideo ? (
          <div
            style={this.show_SubmitButton ? styles.submitButton : styles.submitButtonDisabled}
            key="submit"
            onClick={() => (this.show_SubmitButton ? this.submitVideo() : () => {})}
          >
            {this.props.totalSubmissions === 1 ? 'SUBMIT' : 'UPLOAD'}
          </div>
        ) : null}
        {!this.show_ModeSelector &&
          !this.toBeSubmittedAvailable &&
          !this.state.uploadVideoPreview &&
          !this.uploadedFile &&
          !this.state.uploadingVideo &&
          this.show_SubmitButton && (
            <p style={styles.submitDownloadText}>
              {this.props.totalSubmissions === 1
                ? "As a precaution, this file will also be downloaded on submitting, so it's not lost due to network issues."
                : "As a precaution, this file will also be downloaded when you upload, so it's not lost due to network issues. Note that you'll still have to submit the assignment."}
            </p>
          )}
        {
          <div
            style={[styles.submitButton, this.show_SubmitUploadedVideo ? null : styles.hideButton]}
            key="submitUploaded"
            onClick={() => {
              this.uploadVideoFile(this.uploadedFile, true);
            }}
          >
            {this.props.totalSubmissions > 1 ? (
              <div style={styles.infoIconStyle}>
                <Tooltip text="This will save your response. Note that you'll still have to submit the assignment.">
                  <Icon icon="info" fill="rgba(255, 255, 255, 0.68)" size="22px" />
                </Tooltip>
              </div>
            ) : null}
            {this.props.totalSubmissions === 1 ? 'SUBMIT' : 'UPLOAD VIDEO'}
          </div>
        }
      </div>
      <div style={styles.retakeCancelBtns}>
        <div
          style={[styles.backButton, this.show_BackButton ? null : styles.hideButton]}
          key="back"
          onClick={this.cancelRecorded}
        >
          CANCEL
        </div>
      </div>
    </div>
  );

  showPreviewClicked = () => {
    videorecorder.cancelRecorded();
    this.recordingTimerChange(false);
    videorecorder.showVideoPreviewWithoutRecord(callback => {
      this.setState(
        {
          recordingVideo: false,
          videoRecorded: false,
          recordedVideo: null,
          showingPreviewVideo: true
        },
        () => {
          this.setState({ uploadError: false, uploadFileSizeError: false }, () => {
            callback(this.refs.videoPlayer);
          });
          this.videoPlayer.removeAttribute('controls');
        }
      );
    });
  };

  isEnrolled = () => {
    if (!this.props.isEnrolled) {
      this.props.showEnrollDialog();
      return false;
    }
    return true;
  };

  renderModeSelectButtons() {
    if (!this.show_ModeSelector) return null;
    const featuerFlag = true;
    const useFilestackFilePicker =
      this.context.getFeatureFlag && this.context.getFeatureFlag('use-filestack');

    return (
      <div style={styles.initialButtons}>
        <div
          style={[styles.initialBtn, styles.optRecordVideo]}
          onClick={
            useFilestackFilePicker
              ? this.onSelectMediaPressed('record')
              : () => showVideoResponse(this.props.cardId, this.fileUploaded, 'video-record')
          }
        >
          <div style={[styles.initialBtnIcon, styles.recordIcon]} />
          <div style={styles.optIconsText}>RECORD VIDEO</div>
        </div>
        {featuerFlag && (
          <div
            style={[styles.initialBtn, styles.optRecordVideo]}
            onClick={
              useFilestackFilePicker
                ? this.onSelectMediaPressed('upload')
                : () => showVideoResponse(this.props.cardId, this.fileUploaded, 'video-upload')
            }
          >
            <Icon
              icon="upload-to-cloud"
              viewBox="0 0 32 22"
              fill="#0ABFF1"
              size="32px"
              style={styles.cloudIcon}
            />
            <div style={styles.optIconsText}>Upload Video</div>
          </div>
        )}
        {!featuerFlag && (
          <label style={[styles.initialBtn, styles.optUploadVideo]}>
            <Icon
              icon="upload-to-cloud"
              viewBox="0 0 32 22"
              fill="#0ABFF1"
              size="32px"
              style={styles.cloudIcon}
            />
            <div style={styles.optIconsText}>Upload Video</div>
            <input
              type="file"
              accept="video/webm, video/mp4, video/x-m4v, video/m4v, video/quicktime, video/mov, video/x-msvideo, video/avi"
              ref="videoUploader"
              name="videoFileUpload"
              id="videoFileUpload"
              onChange={this.fileUploadChange}
              style={styles.videoUploadInput}
            />
          </label>
        )}
      </div>
    );
  }

  emptySubmittedResponse = () => {
    this.videoBlobLocalStore('CLEAR');
    this.setState({ responseToBeSubmitted: null }, this.props.responseEnterChange(false));
  };

  getResponse = () => {
    const response = this.props.deletingResponse
      ? ''
      : this.state.responseToBeSubmitted || this.props.response;
    return {
      questionObj: this.props.questionObj,
      emptySubmittedResponse: this.emptySubmittedResponse,
      responseData: {
        questionId: this.props.questionId,
        response,
        answerEvaluation: !response || response !== '' ? '' : 'NA',
        responseType: 'VIDEO',
        deletingResponse: this.props.deletingResponse
      },
      callBack: () => {
        this.videoBlobLocalStore('CLEAR');
        this.uploadedFileObjectUrl = null;
        this.setState({
          uploadingVideo: false,
          uploadSize: false,
          recordedVideo: null,
          videoRecorded: false,
          uploadVideoPreview: false,
          responseToBeSubmitted: null
        });
      }
    };
  };

  statesHelper() {
    const state = this.state;

    this.show_ModeSelector =
      !this.props.response &&
      (!state.recordingVideo &&
        !state.recordedVideo &&
        !state.showingPreviewVideo &&
        !state.uploadingVideo &&
        !state.uploadVideoPreview &&
        (!state.responseToBeSubmitted || state.responseToBeSubmitted === ''));
    this.show_VideoControls = !this.show_ModeSelector && !state.uploadingVideo;
    this.show_RecordButton = state.showingPreviewVideo;
    this.show_StopButton = state.recordingVideo;
    this.show_vc_RetakeButton = state.recordingVideo;

    this.show_SubmitButton = state.recordedVideo;
    this.show_RetakeButton = this.show_SubmitButton && this.show_VideoControls;
    this.show_CancelButton =
      state.recordedVideo &&
      !state.uploadVideoPreview &&
      !state.showingPreviewVideo &&
      this.show_VideoControls;
    this.show_BackButton =
      (state.showingPreviewVideo || state.uploadVideoPreview) && this.show_VideoControls;

    this.show_SubmitUploadedVideo =
      state.uploadVideoPreview && this.uploadedFile && this.show_VideoControls;

    this.toBeSubmittedAvailable =
      (state.responseToBeSubmitted && state.responseToBeSubmitted !== '') ||
      this.props.actualSubmit;
  }

  showTroublePopup = () => {
    this.context.showTroublePopup(true, 'VIDEO');
  };

  render() {
    this.statesHelper();

    return (
      <div>
        <div style={styles.videoWrapper}>
          <div style={styles.videoelementContainer} className="ownSubmissionContainer">
            {this.renderPlayer()}
            {this.state.recordingVideo ? (
              <div style={styles.recordingTimer} ref="recordingTimer" />
            ) : null}
          </div>
          {this.renderVideoControls()}
        </div>
        {this.show_ModeSelector ? <div style={styles.previewLable}>YOUR RESPONSE</div> : null}
        {this.renderModeSelectButtons()}

        {this.renderButtons()}

        {this.renderErrors()}

        {this.renderUploadingStatus()}

        {this.state.unSupported ? (
          <p style={styles.note}>Please visit using HTTPS:// for audio recording support</p>
        ) : null}
        <div className="troubleLink">
          <span onClick={this.showTroublePopup}>Having trouble recording?</span>
        </div>
      </div>
    );
  }

  recordingTimerChange = start => {
    if (start === true) {
      let totalSeconds = 0;
      this.recordingTimer = setInterval(() => {
        if (this.refs.recordingTimer) {
          this.refs.recordingTimer.innerHTML = (() => {
            ++totalSeconds;
            let minute = Math.floor(totalSeconds / 60);
            minute = minute < 10 ? '0' + minute : minute;
            let seconds = totalSeconds - parseInt(minute, 10) * 60;
            seconds = seconds < 10 ? '0' + seconds : seconds;
            return minute + ':' + seconds;
          })();
        }
      }, 1000);
    } else if (start === false) {
      clearInterval(this.recordingTimer);
    }
  };

  checkForLocalVideo = videoBlobRefCode => {
    const localVideo = this.videoBlobLocalStore();
    if (localVideo && typeof localVideo === 'object') {
      if (localVideo.videoState === 'RECORDED') this.stopVideo(false, localVideo.data);
      else if (localVideo.videoState === 'UPLOADED') this.submitVideo(localVideo.data);
    }
  };

  videoBlobLocalStore = (videoBlobData, videoState) => {
    const videoBlobRefCode = `${this.props.questionId}_${this.props.cardId}`;
    if (videoBlobData === 'CLEAR') {
      window.recordedVideoBlobs[videoBlobRefCode] = null;
    } else if (videoBlobData) {
      window.recordedVideoBlobs[videoBlobRefCode] = { videoState, data: videoBlobData };
      return true;
    }

    return window.recordedVideoBlobs[videoBlobRefCode];
  };

  recordVideo = () => {
    videorecorder.cancelRecorded();
    try {
      analytics.track('RECORD', {
        card_name: this.props.cardName,
        card_id: this.props.cardId,
        question_index: this.props.position,
        type: 'video'
      });
      if (this.state.unSupported) {
        return false;
      }
      videorecorder.startRecording(callback => {
        this.setState(
          {
            recordedVideo: false,
            showingPreviewVideo: false,
            recordingVideo: true,
            uploadError: false,
            uploadFileSizeError: false,
            responseToBeSubmitted: null
          },
          () => {
            callback(this.refs.videoPlayer);
          }
        );
        this.videoPlayer.removeAttribute('controls');
        this.recordingTimerChange(true);
      });
    } catch (err) {
      analytics.track('FILE_RECORD_FAILURE', {
        card_name: this.props.cardName,
        question_index: this.props.position,
        error: err.toString && err.toString(),
        stack: err.stack
      });
    }
  };

  stopVideo = (cancelVideo, localVideoData) => {
    if (localVideoData && typeof localVideoData === 'object') {
      this.recordingTimerChange(false);
      this.recordedVideoData = localVideoData;
      this.setState({
        recordedVideo: localVideoData.url,
        recordingVideo: false,
        videoRecorded: true,
        showingPreviewVideo: false,
        uploadError: false,
        uploadFileSizeError: false,
        responseToBeSubmitted: null
      });
    } else {
      videorecorder.stopRecording(data => {
        if (cancelVideo !== true) {
          this.recordingTimerChange(false);
          this.recordedVideoData = data;
          this.setState({
            recordedVideo: data.url,
            recordingVideo: false,
            videoRecorded: true
          });
        } else if (cancelVideo === true) {
        }
      });
    }
  };

  @autobind
  submitVideo(localVideoData) {
    if (localVideoData) {
      this.setState(
        {
          uploadingVideo: false,
          uploadSize: false,
          recordedVideo: null,
          videoRecorded: false,
          responseToBeSubmitted: localVideoData,
          // From this.stopVideo states
          recordingVideo: false,
          showingPreviewVideo: false,
          uploadError: false,
          uploadFileSizeError: false
        },
        () => this.context.checkForSubmit && this.context.checkForSubmit()
      );
      return false;
    }
    try {
      const self = this;
      const fileName =
        user.id() +
        '_' +
        self.props.cardId +
        '_q' +
        self.props.position +
        'v' +
        0 +
        '_' +
        new Date().getTime() +
        '.webm';
      const s3Url = global.constants.s3LyearnAssetsUrl + fileName;

      analytics.track('FILE_UPLOAD_START', {
        fileName: s3Url
      });

      const uploadPromise = uploadToS3(
        s3Url,
        this.recordedVideoData.blobData,
        'video/webm',
        this.uploadProgress
      );
      this.setState({
        uploadingVideo: true,
        uploadSize: this.recordedVideoData.blobData.size
      });
      this.downloadRecordedVideo(this.recordedVideoData.url);
      const downloadRecordedVideo = this.downloadRecordedVideo;

      uploadPromise
        .then(data => {
          window.analytics.track('FILE_UPLOAD_COMPLETE', {
            fileName: s3Url
          });
          self.setState(
            {
              uploadingVideo: false,
              uploadSize: false,
              recordedVideo: null,
              videoRecorded: false,
              responseToBeSubmitted: s3Url
            },
            () => this.props.saveOneResponse(this.getResponse())
          );
          self.props.responseEnterChange(true);
        })
        .catch(reason => {
          console.log(reason);
          SnackBarHelper.showSnackbar({
            label:
              "File Upload failed, please refresh page and try again if you don't see your submitted video.",
            status: 'error',
            duration: 3
          });
          downloadRecordedVideo(this.recordedVideoData.url);
          window.analytics.track('FILE_UPLOAD_FAILURE', {
            fileName: s3Url,
            error: reason && reason.toString && reason.toString(),
            stack: reason && reason.stack
          });
        });
    } catch (err) {
      console.log('sednding failure evebt ', err);
      analytics.track('FILE_UPLOAD_FAILURE', {
        error: err.toString && err.toString(),
        stack: err.stack
      });
    }
  }

  downloadRecordedVideo = videoBlobUrl => {
    if (videoBlobUrl) {
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = videoBlobUrl;
      a.download =
        'recorded_video_' +
        this.props.card.globalPosition +
        '_' +
        this.props.cardName +
        '_' +
        new Date().getTime() +
        '.webm';
      a.click();
      a.parentNode.removeChild(a);
    }
  };

  uploadProgress = event => {
    if (event.lengthComputable && this.refs.progressBar) {
      this.refs.progressBar.max = event.total;
      this.refs.progressBar.value = event.loaded;
    }
  };

  getFileFromURL = url =>
    new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.setRequestHeader('x-amz-acl', 'public-read');
      xhr.setRequestHeader('Content-Type', 'video/webm');

      xhr.onload = () => {
        if (xhr.status === 200) {
          resolve(this.response);
        } else {
          console.log('result err = ', xhr);
        }
      };

      xhr.onerror = err => {
        console.log('err xhr', err);
        reject(err);
      };
      xhr.send();
    });

  fileUploaded = r => {
    TinyPubSub.unsubscribe('UserInteractionBlockChange');
    if (interactionsBlocked()) {
      TinyPubSub.subscribe(
        'UserInteractionBlockChange',
        (e, blocked) => !blocked && this.fileUploaded(r)
      );
      return false;
    }

    if (!r || !r.url) {
      SnackBarHelper.showSnackbar({
        label: 'File Upload failed, please try again.',
        status: 'error'
      });
      window.analytics.track('FILE_UPLOAD_FAILURE', {
        errorMessage: 'Filestack callback function does not contain url to uploaded file'
      });
      return false;
    }

    const url = r.url;
    this.setState(
      {
        uploadingVideo: false,
        uploadSize: false,
        recordedVideo: null,
        videoRecorded: false,
        responseToBeSubmitted: url
      },
      () => this.props.saveOneResponse(this.getResponse())
    );
  };

  cancelRecorded = fromSubmissionCancel => {
    videorecorder.cancelRecorded();
    this.videoBlobLocalStore('CLEAR');
    this.setState(
      {
        recordingVideo: false,
        recordedVideo: null,
        videoRecorded: false,
        showingPreviewVideo: false,
        uploadVideoPreview: false
      },
      () => {
        if (fromSubmissionCancel === true) {
          this.props.responseEnterChange(true);
        }
      }
    );

    this.uploadedFile = null;
    this.recordingTimerChange(false);
    videorecorder && videorecorder.clearStream && videorecorder.clearStream();
    this.videoPlayer && this.videoPlayer.setAttribute('controls', '');

    if (this.state.videoAvailable && this.videoPlayer) {
      this.videoPlayer.src = this.props.response;
      this.videoPlayer.muted = false;
    } else {
      this.setState({
        noVideo: true
      });
    }
  };

  fileUploadChange = () => {
    analytics.track('FILE_SELECTED_TO_BE_UPLOADED', {
      card_name: this.props.cardName,
      card_id: this.props.cardId,
      question_index: this.props.position,
      type: 'video'
    });
    this.setState({
      uploadError: false,
      uploadFileSizeError: false
    });
    const videoUploader = this.refs.videoUploader;
    const uploadFile = videoUploader.files[0];
    if (!uploadFile) {
      return false;
    }
    const fileSize = uploadFile.size / (1000 * 1000);
    console.log('fileSize', fileSize);
    if (fileSize > 2000) {
      console.log('fileupload:: ', 'File size error');
      this.setState({
        uploadFileSizeError: {
          error: true,
          text: 'Uploaded File size is ' + fileSize.toFixed(0) + ' MB. It must be less then 2000 MB'
        }
      });
      return false;
    }
    const extension = uploadFile.name
      .split('.')
      .pop()
      .toLowerCase();
    if (['mp4', 'webm', 'mov'].indexOf(extension) > -1) {
      videoUploader.value = null;
      this.uploadVideoFile(uploadFile);
    } else {
      console.log('fileupload:: ', 'INVALID FILE FORMAT');
      this.setState({
        uploadError: true
      });
    }
  };

  uploadVideoFile = (file, uploadNow) => {
    const self = this;
    const fileName =
      user.id() +
      '_' +
      self.props.cardId +
      '_q' +
      self.props.position +
      'v' +
      0 +
      '_' +
      new Date().getTime() +
      '.' +
      file.name.split('.').pop();
    const s3Url = global.constants.s3LyearnAssetsUrl + fileName;

    analytics.track('FILE_UPLOAD_START', {
      fileName: s3Url
    });

    this.uploadedFile = file;
    this.uploadedFileObjectUrl = window.URL.createObjectURL(file);

    this.setState({
      uploadVideoPreview: true,
      responseToBeSubmitted: null
    });

    if (uploadNow !== true) return false;

    const uploadPromise = uploadToS3(s3Url, file, file.type, this.uploadProgress);
    this.setState({
      uploadingVideo: true,
      uploadSize: file.size
    });

    window.analytics.track('FILE_UPLOAD_COMPLETE', {
      fileName: s3Url
    });
    uploadPromise
      .then(data => {
        window.analytics.track('FILE_UPLOAD_COMPLETE', {
          fileName: s3Url
        });
        self.setState(
          {
            uploadVideoPreview: false,
            uploadingVideo: false,
            uploadSize: false,
            responseToBeSubmitted: s3Url
          },
          () => this.props.saveOneResponse(this.getResponse())
        );
        self.props.responseEnterChange(true);
      })
      .catch(reason => {
        SnackBarHelper.showSnackbar({
          label: 'File Upload failed, please try again.',
          status: 'error'
        });
        analytics.track('FILE_UPLOAD_FAILURE', {
          fileName: s3Url,
          error: reason && reason.toString && reason.toString(),
          stack: reason && reason.stack
        });
      });
  };
}

styles = {
  wrapper: {
    marginTop: '16px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  },
  yourResponse: {
    color: '#CDCDCD'
  },
  image: {
    height: 19,
    width: 19
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  videoWrapper: {
    padding: '10px 0px',
    position: 'relative'
  },
  videoelementContainer: {
    position: 'relative',
    margin: '0 auto',
    width: '534px',
    height: 'auto',
    display: 'block',
    maxWidth: '100%'
  },
  videoElement: {
    height: 'auto',
    display: 'block',
    maxWidth: '100%'
  },
  stopButton: {
    display: 'block',
    padding: '5px 10px',
    background: 'red',
    color: '#fff',
    cursor: 'pointer',
    margin: '0px 10px'
  },
  recordButton: {
    display: 'block',
    padding: '12px 25px',
    color: '#fff',
    cursor: 'pointer',
    margin: '0px 10px',
    fontWeight: '500'
  },
  submitButton: {
    position: 'relative',
    display: 'block',
    padding: '17px 20px',
    minWidth: '248px',
    textAlign: 'center',
    background: '#42c4e3',
    color: '#fff',
    cursor: 'pointer',
    margin: '0px 10px',
    fontWeight: '500',
    fontSize: '13px',
    ':hover': {
      background: '#40ACC5'
    },
    ':active': {
      background: '#2C7587'
    }
  },
  deleteButton: {
    position: 'relative',
    display: 'block',
    padding: '17px 35px',
    minWidth: '100px',
    textAlign: 'center',
    color: '#767e86',
    cursor: 'pointer',
    margin: '10px 10px 10px',
    fontWeight: '500',
    fontSize: '13px'
  },
  backButton: {
    position: 'relative',
    display: 'block',
    padding: '14px 20px',
    minWidth: '80px',
    textAlign: 'center',
    color: '#767e86',
    cursor: 'pointer',
    margin: '10px 10px 0',
    fontWeight: '500',
    fontSize: '13px'
  },
  submitButtonDisabled: {
    display: 'none'
  },
  retakeButton: {
    display: 'block',
    padding: '12px 25px',
    background: 'none',
    color: '#248acb',
    cursor: 'pointer',
    margin: '0px 10px',
    fontWeight: '500'
  },
  strong: {
    fontWeight: '500'
  },
  uploadError: {
    padding: '7px 0px 10px 0px',
    color: '#C00E0E',
    textAlign: 'center'
  },
  videoUploadInput: {
    width: '0.1px',
    height: '0.1px',
    opacity: '0',
    overflow: 'hidden',
    position: 'absolute',
    zIndex: '-1'
  },
  editButton: {
    display: 'block',
    padding: '5px 10px',
    background: 'blue',
    color: '#fff',
    cursor: 'pointer',
    margin: '0px 10px'
  },
  progressBar: {
    width: '80%',
    margin: '0 auto',
    display: 'block'
  },
  noVideo: {
    display: 'none'
  },
  fileSize: {
    textAlign: 'center',
    padding: '10px'
  },
  hideButton: {
    position: 'absolute',
    top: '-7000px',
    left: '-7000px',
    visibility: 'hidden'
  },
  recordingTimer: {
    fontSize: '18px',
    color: '#fff',
    fontWeight: '500',
    position: 'absolute',
    top: '20px',
    right: '20px'
  },
  initialButtons: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  initialBtn: {
    backgroundColor: 'rgba(219, 226, 232, 0.24)',
    border: '1px solid rgba(118,126,134,0.24)',
    borderRadius: '2px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '42.35%',
    boxSizing: 'border-box',
    padding: '16px 1% 12px',
    cursor: 'pointer'
  },
  cloudIcon: {
    margin: '0px auto -6px auto',
    display: 'block'
  },
  optUploadVideo: {
    cursor: 'pointer'
  },
  initialBtnIcon: {},
  recordIcon: {
    height: '22px',
    width: '22px',
    backgroundColor: '#0ABFF1',
    borderRadius: '50%'
  },
  optIconsText: {
    marginTop: '12px',
    fontSize: '13px',
    letterSpacing: '1px',
    color: '#767e86',
    textTransform: 'uppercase',
    fontWeight: '500'
  },
  videoControlsButtonContainer: {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    flexDirection: 'row'
  },
  vc_Record: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.36)',
    border: '1px solid #ffffff',
    borderRadius: '50%',
    height: '40px',
    width: '40px',
    padding: '0px'
  },
  recordBtnInnerCircle: {
    height: '16px',
    width: '16px',
    backgroundColor: '#2ad1ff',
    borderRadius: '50%'
  },
  stopBtnInnerCircle: {
    height: '16px',
    width: '16px',
    backgroundColor: '#fff'
    // borderRadius: '50%',
  },
  retakeBtnIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    height: '40px',
    width: '40px',
    padding: '0px',
    cursor: 'pointer'
  },
  retakeCancelBtns: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 0 10px'
  },
  previewLable: {
    color: '#9ea7b1',
    fontSize: '13px',
    fontWeight: '500',
    letterSpacing: '0.1px',
    padding: '0 0 16px 0'
  },
  infoIconStyle: {
    padding: '0px',
    position: 'absolute',
    top: '4px',
    right: '3px',
    height: 'auto',
    width: 'auto',
    border: 'none'
  },
  submitDownloadText: {
    textAlign: 'center',
    fontSize: '14px',
    maxWidth: '80%',
    padding: '15px 0px 0px',
    color: '#666'
  },
  apologyContainer: {
    padding: '5px 7px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: '100%'
  },
  alertIcon: {
    height: '18px',
    width: '18px',
    marginRight: '5px'
  }
};

export default radium(VideoResponse);
